import { useContext } from 'react';
import StepContext from '../Context/StepContext';

export default () => useContext(StepContext);
